import { head } from 'ramda';
import React, { FC } from 'react';
import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';
import { useVideoPreviews } from '../../../../utils/media-manager-sdk/hooks';
import { IOuter } from '../ItemDemonstration.types';

export const PublicVideo: FC<IOuter> = ({ item, className, saveRef }) => (
  <div className={className} data-hook="expanded-view-public-video-demonstration" ref={saveRef}>
    <video src={head(useVideoPreviews(item as MediaManagerSDKFile))} loop autoPlay width="100%" height="100%" />
  </div>
);
